<template>
    <div v-if="details" :key="lang" class="box">
        <div>{{ details.calc.group1.text }}: {{ details.calc.group1.result }}</div>
        <div v-if="details.calc.group2">
            <hr />
            {{ details.calc.group2.text }}: {{ details.calc.group2.result }}
        </div>
        <div v-if="details.mId">
            <hr />
            {{ "components.pages.history.merchant.id" | translate }}: {{ details.mId }}
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import currencyService from '../../../../../../_common/services/currency.service';

const transactionMap = {
    Deposit: transaction => ({ calc: { group1: { name: 'balance', sign: '+' } }, mId: transaction.merchantOperationId }),
    Withdraw: transaction => ({ calc: { group1: { name: 'pending', sign: '-' } }, mId: transaction.merchantOperationId }),
    TransferRealToRequested: () => ({ calc: { group1: { name: 'balance', sign: '-' }, group2: { name: 'requested', sign: '+' } } }),
    TransferRequestedToReal: () => ({ calc: { group1: { name: 'balance', sign: '+' }, group2: { name: 'requested', sign: '-' } } }),
    TransferRequestedToApproved: () => ({ calc: { group1: { name: 'approved', sign: '+' }, group2: { name: 'requested', sign: '-' } } }),
    TransferApprovedToReal: () => ({ calc: { group1: { name: 'balance', sign: '+' }, group2: { name: 'approved', sign: '-' } } }),
    TransferApprovedToPending: () => ({ calc: { group1: { name: 'approved', sign: '-' }, group2: { name: 'pending', sign: '+' } } }),
    TransferPendingToApproved: () => ({ calc: { group1: { name: 'approved', sign: '+' }, group2: { name: 'pending', sign: '-' } } })
};

export default {
    name: 'merchant-operation',
    props: {
        transaction: { type: Object, required: true }
    },
    data: () => ({ details: null }),
    computed: {
        lang: () => Vue.state.lang.currentLang
    },
    watch: {
        lang: function() {
            this.loadDetails();
        }
    },
    mounted() {
        this.loadDetails();
    },
    methods: {
        loadDetails() {
            const format = amount => currencyService.format(amount, this.transaction.currency);
            this.details = transactionMap[this.transaction.type](this.transaction);

            Object.keys(this.details.calc).forEach(key =>
                (group => {
                    group.text = this.$t(`components.pages.history.merchant.group.${group.name}`);
                    group.result = `${format(this.transaction[`${group.name}Before`])} ${group.sign} ${format(
                        this.transaction.amount
                    )} = ${format(this.transaction[`${group.name}After`])}`;
                })(this.details.calc[key])
            );
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/history/merchant-operation.vue